<template>
  <div class="w-view-shell">
    <!-- 面包屑  -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="'/'">首页</el-breadcrumb-item>
      <el-breadcrumb-item>开始学习</el-breadcrumb-item>
      <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="box">
      <div class="herd">
        <span class="count" v-if="title != '错题集'"
          >倒计时 {{ down_tips }}</span
        >
        <div class="nuber">已答{{ current_topic }}/{{ topic_num }}</div>
      </div>
      <div class="topic-list">
        <div class="topic-box" v-for="(i, n) in topic_list" :key="n + 'a'">
          <div class="topic">
            <div class="topic-type">{{ i.qst_type | setType }}</div>
            <span>{{ n + 1 }}.</span>
            <p v-html="i.qst_name"></p>
          </div>

          <div class="content">
            <div
              class="option-box"
              v-for="(item, index) in i.qst_info"
              :key="index">
              <div
                class="select-box"
                @click.stop="select_option(index, n)"
              >
                <img
                  src="@/assets/icon_check.png"
                  alt=""
                  v-show="item.is_select == 1"
                />
                <img
                  src="@/assets/cuowu.png"
                  alt=""
                  v-show="item.is_select == 2"
                />
              </div>
              <div class="option-val">
                <div>[{{ option_num[index] }}].</div>
                <p v-html="item.option"></p>
              </div>
            </div>
          </div>
          <div class="answer-shell">
            <van-button
              v-if="i.show_answer"
              class="conceal"
              :class="{ conceals: i.is_error }"
              @click="conceal(n)"
            >
              隐藏答案
            </van-button>
            <van-button v-else class="conceal" @click="conceal(n)"
              >显示答案
            </van-button>
            <span class="ok" v-if="i.show_answer">
              正确答案：
              <span v-for="(item2, index2) in i.qst_answer" :key="index2">{{
                option_num[item2 - 1]
              }}</span>
            </span>
            <div class="planning" v-if="i.show_answer && i.analyze">
              答案解析：{{ i.analyze }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Btn">
      <!--            <el-button @click="noTopic">上一题</el-button>-->
      <!--            <el-button @click="next()">下一题</el-button>-->
      <el-button @click="paper">交卷</el-button>
    </div>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";

export default {
  name: "test",
  data() {
    return {
      current_topic: 0,
      title: "模拟练习",
      time: 3550,
      down_tips: "",
      topic_num: 0,
      option_num: ["A", "B", "C", "D", "E", "F", "G", "H"],
      topic_current: 0,
      answer_num: 1,
      topic_list: [
        {
          qst_name: "",
        },
      ],
      sqeq: false,
      radio: false,
      isActive: false,
      page_size: 1000,
      page: 1,
      use_time: 0,
      timer: null,
      belong: 0, // 0.模拟测试 1.随堂练习
    };
  },
  filters: {
    setType(value) {
      if (value == 0) {
        return "单选";
      }
      if (value == 1) {
        return "多选";
      }
      if (value == 2) {
        return "判断";
      }
    },
  },
  mounted() {
    this.belong = this.$route.query.belong;
    if (this.$route.query.qst_id) {
      this.qst_id = this.$route.query.qst_id;
      if (this.$route.query.error_type) {
        this.title = "错题集";
        this.get_error_list();
      } else {
        this.get_topic_list();
      }
    }
  },
  methods: {
    get_error_list() {
      // 错误列表
      this.API.post("user/question_in-get_mistakes_list", {
        qst_id: this.qst_id,
        page: 1,
        page_size: 100,
      }).then((res) => {
        this.topic_num = res.data.mistake_cnt;
        for (let i = 0; i < res.data.mistakes_list.length; i++) {
          res.data.mistakes_list[i].answer = '';
          res.data.mistakes_list[i].show_answer = false
          for (
            let j = 0;
            j < res.data.mistakes_list[i].qst_info[j].length;
            j++
          ) {
            res.data.mistakes_list[i].qst_info[j].is_select = 0;
          }
        }
        this.topic_list = res.data.mistakes_list;
        this.down_time();
      });
    },
    count_select() {
      let select_num = 0;
      for (let i = 0; i < this.topic_list.length; i++) {
        if (this.topic_list[i].answer) {
          select_num += 1;
        }
      }
      this.current_topic = select_num;
    },
    select_option(index, n) {
      // console.log(this.topic_list[n])
      // if (this.topic_list[n].is_error) {
      //   //   多选 答错
      //   return;
      // }
      let answers = [];
      if (this.topic_list[n].qst_type === 1) {
        // 多选
        if (this.topic_list[n].qst_answer.indexOf(index + 1) !== -1) {
          this.topic_list[n].qst_info[index].is_select = 1;
        } else {
          // 答错了
          this.topic_list[n].qst_info[index].is_select = 2;
          this.topic_list[n].is_error = true;
        }
        for (let i = 0; i < this.topic_list[n].qst_info.length; i++) {
          if (this.topic_list[n].qst_info[i].is_select != 0) {
            answers.push(i + 1);
          }
        }
      } else {
        // 单选
        for (let i = 0; i < this.topic_list[n].qst_info.length; i++) {
          this.topic_list[n].qst_info[i].is_select = 0;
        }
        if (this.topic_list[n].qst_answer.indexOf(index + 1) !== -1) {
          this.topic_list[n].qst_info[index].is_select = 1;
        } else {
          this.topic_list[n].qst_info[index].is_select = 2;
          this.topic_list[n].is_error = true;
        }
        answers.push(index + 1);
      }
      this.topic_list[n].answer = answers.join("");
      this.count_select();
    },
    paper(type) {
      // 交卷
      let _this = this;
      if (_this.$route.query.error_type) {
        _this.$router.back();
        return;
      }
      let question_info = [];
      for (let i = 0; i < this.topic_list.length; i++) {
        if (!_this.topic_list[i].answer && _this.topic_list[i].answer != 0) {
          return _this.API.SMessage("答题未完成");
        }
        let data = {
          info_id: _this.topic_list[i].info_id, //1
          option: _this.topic_list[i].answer, //2
        };
        question_info.push(data);
      }

      function succend() {
        _this.API.post("user/question_in-push_question", {
          qst_id: _this.qst_id,
          belong: _this.belong,
          use_time: _this.use_time,
          question_info: question_info,
        }).then((res) => {
          // _this.$router.push('/fulfillTest?info=' + JSON.stringify(res.data))
          _this.$router.back();
        });
      }

      if (type) {
        succend();
      } else {
        MessageBox({
          title: "提示",
          message: "您确定要交卷吗",
          showCancelButton: true,
        })
          .then((action) => {
            succend();
          })
          .catch(() => {});
      }
    },
    down_time() {
      // 答题倒计时
      let d = 0;
      let h = 0;
      let m = 0;
      let s = 0;
      let time = this.time;
      this.use_time = 0;
      this.timer = setInterval(() => {
        if (time === 0) {
          return clearInterval(this.timer);
        }
        time--;
        this.use_time++;
        d = parseInt(time / (24 * 60 * 60));
        h = parseInt((time / (60 * 60)) % 24);
        m =
          parseInt(time / 60) < 10
            ? "0" + parseInt(time / 60)
            : parseInt(time / 60);
        s =
          parseInt(time % 60) < 10
            ? "0" + parseInt(time % 60)
            : parseInt(time % 60);
        this.down_tips = m + ":" + s;
      }, 1000);
    },
    conceal(n) {
      this.topic_list[n].show_answer = !this.topic_list[n].show_answer
    },
    get_topic_list() {
      this.API.post("user/course_in-get_simulation_qst", {
        qst_id: this.qst_id,
        page_size: this.page_size,
        page: this.page,
      }).then((res) => {
        this.topic_num = res.data.cnt_qst;
        this.time = res.data.total_time;
        for (let i = 0; i < res.data.question_list.length; i++) {
          res.data.question_list[i].answer = null;
          res.data.question_list[i].show_answer = false;
          for (
            let j = 0;
            j < res.data.question_list[i].qst_info[j].length;
            j++
          ) {
            res.data.question_list[i].qst_info[j].is_select = false;
          }
        }
        this.topic_list = res.data.question_list;
        this.down_time();
      });
    },
  },
  beforeDestroy() {},
  destroyed() {
    window.clearInterval(this.timer);
    // window.removeEventListener('popstate', this.goBack, false);
  },
};
</script>

<style lang="less" scoped>
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}

.el-breadcrumb {
  height: 47px;
  font-size: 16px;
  margin: 20px 0;
  line-height: 47px;
}

.box {
  width: 1200px;
  padding-bottom: 20px;
  margin: 10px 0;
  border: 1px solid #d3d3d3;
}

.herd {
  display: flex;
  height: 80px;
  justify-content: space-between;
  margin: 16px 36px 0 36px;
  border-bottom: 1px solid #ccc;

  .count {
    height: 29px;
    font-size: 30px;
    font-family: PingFang SC;
    color: #32b16c;
    line-height: 97px;
  }

  .nuber {
    height: 26px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 97px;
  }
}

.topic {
  margin: 16px 36px 0 36px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  font-size: 28px;
  display: flex;
  span {
    font-size: 28px;
  }
  > p {
    flex: 1;
    font-size: 28px;
    display: inline-block;
    /deep/ p {
      font-size: 28px;
    }
  }
}

.content {
  margin: 20px 10px 0 36px;

  .option-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .select-box {
    width: 30px;
    min-width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid #acacac;
    margin-right: 20px;
    cursor: pointer;
  }

  .option-val {
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    display: flex;
    > div {
      font-size: 28px;
    }
    /deep/ p {
      font-size: 28px;
    }
  }
}

/deep/ .van-radio__label {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 54px;
  margin-bottom: 20px;
}

.planning {
  margin-bottom: 30px;
  padding: 20px;
  width: 1090px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 65px;
  border: 1px dashed #dcdcdc;
}

/deep/ .van-icon {
  position: relative;
  top: -8px;
  margin-right: 10px;
}

.conceal {
  margin: 20px 20px 20px 0;
  width: 170px;
  height: 70px;
  background: #2aaab6;
  border-radius: 5px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

.conceals {
  margin: 20px 20px 20px 0;
  width: 170px;
  height: 70px;
  background: #e81826 !important;
  border-radius: 5px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

.ok {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 54px;
}

.Btn {
  display: flex;
  justify-content: center;
  position: relative;
  margin: 0 auto 50px;

  .el-button:nth-child(1) {
    width: 190px;
    height: 76px;
    background: #208be6;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-right: 20px;
  }

  .el-button:nth-child(2) {
    width: 190px;
    height: 76px;
    background: #1dacf9;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-right: 20px;
  }

  .el-button:nth-child(3) {
    width: 190px;
    height: 76px;
    background: #32b16c;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}

.topic-type {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 40px;
  border: 1px solid #2aa9b5;
  border-radius: 5px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2baab5;
  margin-right: 10px;
}

.topic-list {
  height: 50vh;
  overflow-y: scroll;
}

.topic-box {
  margin-bottom: 50px;
}
.answer-shell {
  padding-left: 40px;
}
</style>
